import MaestroLoader from "@components/MaestroLoader";
import { Card } from "@mui/joy";

export function LoadingWidget() {
    return (
        <Card variant="soft" sx={{height: '100%', justifyContent: 'center'}}>
            <MaestroLoader style={{alignSelf: 'center'}} />
        </Card>
    );
}
